import Vuex, {StoreOptions} from 'vuex';
import VueI18n, {DateTimeFormats} from 'vue-i18n';
import JhiFormatter from './formatter';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import {setupAxiosInterceptors} from '@/shared/config/axios-interceptor';

import VueCookie from 'vue-cookie';
import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';

import * as filters from '@/shared/filters/filters';
import {accountStore} from '@/shared/store/account-store';
import {translationStore} from '@/shared/store/translation-store';
import {appStore} from '@/shared/store/app-store';
import {restaurantStore} from '@/shared/store/restaurant-store';
import {restaurantMenuStore} from '@/shared/store/restaurant-menu-store';
import {marketerStore} from '@/shared/store/marketer-store';
import {RootState} from '../store/types';
import {restaurantsStore} from '@/shared/store/restaurants-store';
import {supportStore} from '@/shared/store/support-store';

const dateTimeFormats: DateTimeFormats = {
  de: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  // jhipster-needle-i18n-language-date-time-format - JHipster will add/remove format options in this object
};

export function initVueApp(vue) {
  vue.use(VueCookie);
  vue.use(Vuelidate);
  vue.use(Vue2Filters);
  setupAxiosInterceptors(() => console.log('Unauthorized!'));
  filters.initFilters();
}

export function initI18N(vue) {
  vue.use(VueI18n);
  return new VueI18n({
    dateTimeFormats,
    silentTranslationWarn: true,
    formatter: new JhiFormatter(),
  });
}

export function initVueXStore(vue) {
  vue.use(Vuex);

  const store: StoreOptions<RootState> = {
    modules: {
      accountStore,
      translationStore,
      appStore,
      restaurantStore,
      restaurantsStore,
      restaurantMenuStore,
      marketerStore,
      supportStore,
    },
  };

  return new Vuex.Store<RootState>(store);
}

export function initVuetify(vue) {
  vue.use(Vuetify);
  const opts = {
    theme: {
      dark: false,
      themes: {
        light: {
          primary: '#D72323',
          secondary: '#2c3e50',
        },
        dark: {
          primary: '#D72323',
          secondary: '#2c3e50',
        },
      },
    },
  };
  return new Vuetify(opts);
}
